import { RootState } from '../../interfaces/rootState';

export const TemplateListSelector = ({ templateList }: RootState) => templateList.templateList;

export const TemplateListCountSelector = ({ templateList }: RootState) => templateList.totalCount;
